import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import actions from "actions";
import WebinarList from "components/Admin/StudyGroups/Webinar/List";
import { push } from "redux-router";
import Toolbar from "components/Admin/StudyGroups/Webinar/Toolbar";

const { loadAdminWebinarsSaga, showDeleteWebinarsConfirmationModal } = actions;

class GroupWebinars extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      webinar_ids: [],
      page: props.page || 1,
      query: {
        title: "",
        date_from: null,
        date_to: null,
        group_id: props.params.id,
        order: {
          created_at: "desc",
        },
      },
    };
  }

  componentWillMount = () => {
    this.loadWebinars();
  };

  deleteWebinars = () => {
    if (this.state.webinar_ids.length > 0)
      this.props.deleteWebinars(this.state.webinar_ids);
  };

  onChangePage = (page = 1) => {
    this.setState(
      {
        page,
      },
      this.loadWebinars
    );
  };

  checkedWebinarIds = (webinar_id) => {
    var ids = _.assign(this.state.webinar_ids),
      index = this.state.webinar_ids.indexOf(webinar_id);

    if (index == -1) {
      ids.push(webinar_id);
    } else {
      ids.splice(index, 1);
    }
    this.setState({ webinar_ids: ids });
  };

  loadWebinars = () =>
    this.props.loadWebinars(this.state.page, this.state.query);

  changeQuery = (query, timeout = 500) => {
    this.setState({ query }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.loadWebinars, timeout);
    });
  };

  onOrderChange = (field = "created_at", order = "desc") => {
    const query = {
      ...this.state.query,
      order: {
        [field]: order,
      },
    };
    this.changeQuery(query, 0);
  };

  onChangeQuery = (field, value) => {
    const query = { ...this.state.query, ...{ [field]: value } };
    this.setState({ page: 1 }, () => {
      this.changeQuery(query);
    });
  };

  onDateRangeChange = (field, start, end) => {
    const query = {
      ...this.state.query,
      ...{ [`${field}_from`]: start, [`${field}_to`]: end },
    };
    this.setState({ page: 1 }, () => {
      this.changeQuery(query);
    });
  };

  render() {
    const { deleteWebinars, state, onChangeQuery, onDateRangeChange } = this;
    const { params } = this.props;
    return (
      <main className="site--width clearfix">
        <div className="container_admin_webinar"></div>
        <Toolbar
          filterProps={{
            ...state,
            onDateRangeChange,
            onChangeQuery,
          }}
          groupId={params.id}
          toolsProps={{
            count: this.props.count,
            deleteWebinars,
          }}
        />
        <div className="admin_webinars_table admin_table">
          <WebinarList
            role={this.props.role}
            webinars={this.props.webinars}
            navigateToWebinar={this.props.navigateToWebinar}
            navigateToFeedback={this.navigateToFeedback}
            navigateToWebinarsUsers={this.props.navigateToWebinarsUsers}
            navigateToWebinarsUsersSession={
              this.props.navigateToWebinarsUsersSession
            }
            navigateToWebinarsUsersNewsletter={
              this.props.navigateToWebinarsUsersNewsletter
            }
            navigateToCertificates={this.props.navigateToCertificates}
            groupId={params.id}
            checkedWebinarIds={this.checkedWebinarIds}
            webinar_ids={this.state.webinar_ids}
            onOrderChange={this.onOrderChange}
            query={this.state.query}
            navigateToFeedbackEdit={this.props.navigateToFeedbackEdit}
            paginationProps={{
              onChangePage: this.onChangePage,
              page: this.state.page,
              total_pages: this.props.total_pages,
            }}
          />
        </div>
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    webinars: state.webinars.adminWebinars.values,
    count: state.webinars.adminWebinars.count,
    total_pages: state.webinars.adminWebinars.total_pages,
    page: state.webinars.adminWebinars.page,
    query: state.webinars.adminWebinars.query,
    role: state.users.user.role,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch,
    navigateToWebinar: (groupId, id) =>
      dispatch(push(`/groups/${groupId}/webinars/${id}`)),
    navigateToFeedback: (webinar) =>
      dispatch(
        push(`/webinars/${webinar.id}/feedback/${webinar.feedback_form_id}`)
      ),
    navigateToWebinarsUsers: (id) => dispatch(push(`/webinars/${id}/users`)),
    navigateToWebinarsUsersNewsletter: (id) =>
      dispatch(push(`/webinars/${id}/newsletter`)),
    navigateToWebinarsUsersSession: (id) =>
      dispatch(push(`/webinars/${id}/sessions`)),
    navigateToFeedbackEdit: (id) => dispatch(push(`/feedbackform/${id}`)),
    navigateToCertificates: (groupId, webinarId) =>
      dispatch(push(`/groups/${groupId}/webinars/${webinarId}/certificates`)),
    deleteWebinars: (webinar_ids) =>
      dispatch(showDeleteWebinarsConfirmationModal(webinar_ids)),
    loadWebinars: (page, query) => dispatch(loadAdminWebinarsSaga(page, query)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupWebinars);



// WEBPACK FOOTER //
// ./src/containers/Admin/StudyGroups/GroupWebinars.jsx